module.exports = __webpack_public_path__ + "static/media/johnJones23.7f5b0c1c.png";